import { render } from "./CustomizeClientSubscriptionForm.vue?vue&type=template&id=b9d6ee5a"
import script from "./CustomizeClientSubscriptionForm.vue?vue&type=script&lang=js"
export * from "./CustomizeClientSubscriptionForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__